import { Component, ViewChild } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { Modal } from 'ngx-modal';

import { PasswordService } from 'app/api/resources/password.service';
import { SessionService } from 'app/api/session.service';

@Component({
  selector: 'update-password',
  styles: [require('./update-password.component.less')],
  template: require('./update-password.component.html'),
  providers: [PasswordService, SessionService],
})
export class UpdatePasswordComponent {
  oldPassword: string;
  newPassword: string;
  repeatPassword: string;
  matchError: boolean = false;
  validationError: boolean = false;
  loading: boolean = false;
  success: boolean = false;
  updateError: boolean = false;
  passwordChange: boolean = false;
  message: string;

  @ViewChild(Modal) updateMsgModal: Modal

  constructor(
    private route: ActivatedRoute,
    private session: SessionService,
    private password: PasswordService
  ) { }

  ngOnInit() {
    // Check if logout occurred because password expired and show message
    if(this.route.snapshot.queryParams['update_msg']) {
      this.updateMsgModal.open();
    }
  }

  validate($event) {
    this.validationError = !$event;
  }

  match($event) {
    this.matchError = !$event;
    this.passwordChange = !this.validationError && !this.matchError;
  }

  // Submit password reset
  updatePassword() {
    this.loading = true;
    this.password.changePassword(this.oldPassword, this.newPassword)
      .subscribe((res: Response) => {
        this.loading = false;
        this.updateError = false;
        this.success = true;
      }, (err: any) => {
        this.loading = false;
        this.message = err.json().message;
        if (this.message === 'old password does not match') {
          this.updateError = true;
        } else if (this.message === 'new password can not match old password') {
          this.updateError = true;
        } else {
          this.message = 'Sorry, an unknown error has occurred, please check your internet connection and try again.'
          this.updateError = true;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/update-password/update-password.component.ts